import { Component, Input } from '@angular/core';

export type SalesInsightsCardAccent = 'primary' | 'danger';

@Component({
  selector: 'lib-sales-insights-card',
  standalone: false,
  templateUrl: './sales-insights-card.component.html',
  styleUrl: './sales-insights-card.component.scss'
})
export class SalesInsightsCardComponent {
  @Input() cardTitle?: string;
  @Input() subtitle?: string;
  @Input() accent?: SalesInsightsCardAccent | null;
  @Input() accentRgb?: string | null;
  @Input() loading = false;
  @Input() error?: string | null;
  @Input() empty = false;
}
